module.exports = __webpack_public_path__ + "img/client-9.1039f589.webp";